import { api } from '@/lib/api';
import type {
  TransmitterRawEventDetail,
  TransmitterRawEventDetailKey,
  TransmitterRawEventsFilters,
  TransmitterRawEventsResponse,
} from './types';

export async function listTransmitterRawEvents(
  filters: TransmitterRawEventsFilters,
): Promise<TransmitterRawEventsResponse> {
  const params: Record<string, string | number> = {
    pageNumber: filters.pageNumber ?? 0,
    pageLength: filters.pageLength ?? 50,
  };

  if (filters.ignoreTimeRange) {
    params.ignoreTimeRange = 'true';
  } else {
    if (filters.from) params.from = filters.from;
    if (filters.to) params.to = filters.to;
  }
  if (filters.search) params.search = filters.search;
  if (filters.source) params.source = filters.source;
  if (filters.status) params.status = filters.status;

  return api.get<TransmitterRawEventsResponse>('/v4/transmitter-raw-events', params);
}

export async function getTransmitterRawEventDetail(
  key: TransmitterRawEventDetailKey,
): Promise<TransmitterRawEventDetail> {
  return api.get<TransmitterRawEventDetail>('/v4/transmitter-raw-events/detail', {
    receivedAt: key.receivedAt,
    source: key.source,
    messageId: key.messageId,
  });
}
